import { encodeArk } from '@fs/zion-ark'

export default function getApidsFromOralGen(apidList) {
  return apidList.map((apidAndPath, index) => {
    const justTheApid = apidAndPath.split('/')[0]
    const thumbnail = `https://sg30p0.familysearch.org/service/records/storage/dascloud/das/v2/${apidAndPath}`
    // This is the url for deep zoom images, but they all seem not to work. We'll see if it ever used
    // const deepzoom = `https://sg30p0.familysearch.org/service/records/storage/dascloud/das/v2/${justTheApid}/image.xml`

    return {
      srcSet: {
        0: thumbnail,
        500: thumbnail,
      },
      alt: justTheApid,
      id: justTheApid,
      ark: encodeArk(justTheApid),
      index,
    }
  })
}
